(function() {
  function boot(){ setTimeout(canvas_123, 200); }
  if (document.readyState === 'loading') { document.addEventListener("DOMContentLoaded", boot); } else { boot(); }
})();
/* Zewearsy fix: failsafe reveal utk elemen .wow yg masih hidden (kalau WOW gagal/telat) */
(function(){
  function revealStuck(margin){
    try {
      var els = document.querySelectorAll('.wow');
      for (var i=0;i<els.length;i++){
        var el = els[i];
        if (getComputedStyle(el).visibility === 'hidden'){
          var r = el.getBoundingClientRect();
          if (r.top < (window.innerHeight - margin) && r.bottom > -400) { el.style.visibility = 'visible'; el.style.animationName = 'none'; }
        }
      }
    } catch(e){}
  }
  function boot(){
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){ setTimeout(function(){revealStuck(20);}, 2500); }); }
    else { setTimeout(function(){revealStuck(20);}, 2500); }
    window.addEventListener('load', function(){ setTimeout(function(){revealStuck(20);}, 1000); });
    var t=null;
    window.addEventListener('scroll', function(){ if (t) clearTimeout(t); t=setTimeout(function(){revealStuck(250);}, 700); }, {passive:true});
  }
  boot();
})();